"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SERVICE_DICT = void 0;
exports.SERVICE_DICT = new Map([["krs-add-in-app-v1", "WORD"], ["krs-calc-add-in-app-v1", "EXCEL"], ["download_pdf", "DOWNLOAD PDF"]]);
